import { useFormContext } from "react-hook-form";
import ErrorMessage from "../../ErrorMessage";
import ErrorInput from "../Error";
import _ from "lodash";

const TextInput = ({ name, serverErrors, ...props }) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();
  return (
    <div className="w-full">
      <input
        type="text"
        className={`w-full mb-1 placeholder:text-inputGrayColor placeholder:text-sm ${
          _.get(errors, name)
            ? "text-errorColor border-errorColor focus:text-errorColor focus:border-errorColor focus:bg-white placeholder:text-errorColor"
            : ""
        }`}
        {...register(name)}
        {...props}
      />

      <ErrorInput name={name} errors={errors} serverErrors={serverErrors} />
    </div>
  );
};

export default TextInput;
